interface ILabelProps {
    htmlFor?: string;
    className?: string;
    children: React.ReactNode;
}

export default function Label({ htmlFor, className, children }: ILabelProps) {
    return (
        <label className={className} htmlFor={htmlFor}>{children}</label>
    );
}